"use client";
import { Image, Link } from "@labs/schema";
import { useRive } from "@rive-app/react-canvas";
import { useReducedMotion } from "framer-motion";
import React from "react";
import { useIntl } from "../../../utils/intl";
export function HeroSection(props) {
    var _props_currentPage_localizations;
    var activeLinkClass = "text-purple";
    var intl = useIntl();
    var RiveComponent = useRive({
        src: "/images/al_logo_purple.riv",
        autoplay: useReducedMotion() ? false : true
    }).RiveComponent;
    return /*#__PURE__*/ React.createElement("header", {
        className: "relative h-screen lg:min-h-[650px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-white absolute top-0 inset-x-0 pt-[3.3rem] md:pt-[4.5rem]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between pb-4 md:pb-8 h-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex pl-[30px] md:pl-[44px]"
    }, (_props_currentPage_localizations = props.currentPage.localizations) === null || _props_currentPage_localizations === void 0 ? void 0 : _props_currentPage_localizations.map(function(Localization, index) {
        return /*#__PURE__*/ React.createElement(Link, {
            href: Localization.link,
            key: index,
            className: "small mb-0 text-black transition hover:text-purple mr-2.5 z-10",
            activeClassName: activeLinkClass
        }, /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": true
        }, Localization.label), /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, Localization.label === "DE" ? "Deutsch" : "English"));
    })), /*#__PURE__*/ React.createElement(Link, {
        href: intl.locale === "de" ? "/de" : "/",
        className: "absolute top-14 md:top-[4.5rem] left-1/2 -translate-x-1/2 text-center flex justify-center w-auto",
        title: "Home"
    }, /*#__PURE__*/ React.createElement(RiveComponent, {
        "aria-label": "Amazee Labs",
        role: "img",
        className: "w-64 h-10 mt-20 md:-mt-3.5 lg:-mt-2.5"
    })))), props.currentPage.heroImage ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "container-page absolute top-1/2 lg:top-[calc(50%+1.5rem)] -translate-y-1/2 inset-x-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "mx-auto tagline lg:max-w-[992px]"
    }, props.currentPage.title))), /*#__PURE__*/ React.createElement(Image, {
        source: props.currentPage.heroImage.mobile,
        alt: props.currentPage.title,
        className: "md:hidden w-full object-cover object-center block h-full",
        priority: true
    }), /*#__PURE__*/ React.createElement(Image, {
        source: props.currentPage.heroImage.desktop,
        alt: props.currentPage.title,
        className: "hidden md:block w-full object-cover object-center h-full",
        priority: true
    })) : null);
}
